import React, { useEffect, useState } from 'react';
import TOCModal from './TOCModal';
import { useSelector } from 'react-redux';
import { getTOC } from '../../helper';
import { TocElement } from '../../types/TocElement';

interface TOCItem {
    title: string;
    href: string;
}
interface TOCProps {
    bookUri: string;
    offset: number;
}

const extractChapterInfo = (toc: TOCItem[], offset: number): TocElement[] => {
    return toc
        .map((item) => {
            // Extract the page number
            const pageMatch = item.href.match(/page(\d+)\.xhtml/i);
            const pageNumber = pageMatch ? parseInt(pageMatch[1], 10) : 0;
            const href = item.href;
            return {
                name: item.title,
                page: pageNumber,
                href: href,
            };
        })
        .filter(({ page }) => page - offset + 1 > 0);
};

const TOC: React.FC<TOCProps> = ({ bookUri, offset }) => {
    const isopenToc = useSelector(
        (state: { TOCOpen: { isOpen: boolean } }) => state.TOCOpen.isOpen
    );
    const [isModalOpen, setIsModalOpen] = useState<boolean>(isopenToc);
    const [toc, setToc] = useState<TocElement[]>([]);

    useEffect(() => {
        const fetchTOC = async () => {
            const res = await getTOC(bookUri);
            const filtered_res = await extractChapterInfo(res, offset);
            setToc(filtered_res);
        };
        fetchTOC();
    }, [bookUri, offset]);

    useEffect(() => {
        setIsModalOpen(isopenToc);
    }, [isopenToc]);

    return (
        <div className="z-30">
            {isModalOpen && <TOCModal chapters={toc} offset={offset} />}
        </div>
    );
};

export default TOC;
